import React from 'react';
import PropTypes from 'prop-types';
import MuiTableBody from '@material-ui/core/TableBody';
import TableRow from './TableRow';
import TableBodyCell from './TableBodyCell';
import styled from 'src/ui/library/styled';
import TableSelectBodyCell from './TableSelectBodyCell';

const styles = theme => ({
  root: {},
});

class TableBody extends React.Component {
  static propTypes = {
    /** Data that will be used to describe rows */
    rows: PropTypes.array.isRequired,
    /** Data that will be used to describe columns */
    columns: PropTypes.array.isRequired,
    /**
     * Read Only mode will force table to ignore renderComponent per columns and display cell value.
     * It will also make rows not selectable.
     */
    readOnly: PropTypes.bool.isRequired,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool.isRequired,
    /** Callback reference to the internal setState */
    setUpdateSelectCell: PropTypes.func.isRequired,
    /** Callback function for to handle row selection */
    onRowSelect: PropTypes.func.isRequired,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  render() {
    const {
      rows,
      setUpdateComponent,
      onRowClick,
      onCellClick,
      setUpdateSelectCell,
      styleOverrides,
      onRowSelect,
      selectableRows,
      columns,
      readOnly,
      hardDisplay,
      disableRow
    } = this.props;
    const totalColumns = columns.length;
    const totalRows = rows.length;

    return (
      <MuiTableBody>
        {rows.map((row, rowIndex) => (
          <TableRow
            key={rowIndex}
            rowType={'body'}
            rowIndex={rowIndex}
            onClick={onRowClick.bind(null, {
              rowIndex,
              origRowIndex: row[0].origRowIndex,
            })}>
            {!readOnly && selectableRows && (
              <TableSelectBodyCell rowIndex={rowIndex} rowData={row} setUpdateSelectCell={setUpdateSelectCell} onRowSelect={onRowSelect} />
            )}
            {row.map((col, colIndex) =>
              columns[colIndex].visible ? (
                <TableBodyCell
                  oddRow={rowIndex % 2 !== 0}
                  evenRow={rowIndex % 2 === 0}
                  lastRow={rowIndex + 1 === totalRows}
                  totalColumns={totalColumns}
                  colIndex={colIndex}
                  rowIndex={rowIndex}
                  rowData={row}
                  cellData={col}
                  onRowSelect={onRowSelect}
                  selectableRows={selectableRows}
                  columnData={columns[colIndex]}
                  styleOverrides={styleOverrides.TableBodyCell}
                  setUpdateComponent={setUpdateComponent}
                  key={colIndex}
                  onClick={onCellClick.bind(null, {
                    rowIndex,
                    colIndex,
                    origRowIndex: col.origRowIndex,
                  })}
                  hardDisplay={hardDisplay}
                  disableRow={disableRow}
                />
              ) : null,
            )}
          </TableRow>
        ))}
      </MuiTableBody>
    );
  }
}

export default styled(TableBody)(styles);
